import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getCategoriaContasBancarias, cadastrarCategoriaContasBancarias, alterarCategoriaContasBancarias, excluirCategoriaContasBancarias, } from './categorias_contas_bancarias_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var CategoriasContasBancariasAlterar = function () {
    var services = {
        getItem: getCategoriaContasBancarias,
        cadastrarItem: cadastrarCategoriaContasBancarias,
        alterarItem: alterarCategoriaContasBancarias,
        excluirItem: excluirCategoriaContasBancarias,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.CATEGORIAS_CONTAS_BANCARIAS, paginaPermissao: FUNCIONALIDADES.CATEGORIAS_CONTAS_BANCARIAS, rota: ROUTES.CATEGORIAS_CONTAS_BANCARIAS, services: services });
};
export default CategoriasContasBancariasAlterar;
